import React, { useContext } from 'react'
import styled  from 'styled-components'
import { Row, Col } from 'react-bootstrap'
import { I18nContext } from 'i18n'
import logo from 'images/logo_data_center.png'
import { Link, CustomLinks } from 'components'
import { useSystem } from 'hooks/useSystem'

const links = [
  'FOOTER.TERMS_SERVICE',
  'FOOTER.DATA_TERMS',
  'FOOTER.MEMBER_POLICY',
  'FOOTER.HELP_INFO',
  'FOOTER.PROVIDERS',
]

const Footer = () => {
  const { translate } = useContext(I18nContext)
  const { globalVersion, environment, lastDeploymentDate } = useSystem()

  return (
    <StyledFooter className="small-font">
      <div className="mx-5">
        <Row>
          <Col>
            <div className="mb-2 pt-2">
              {
                links.map((link, index) => (
                  <span key={link}>
                    {index > 0 && ' | '}
                    <CustomLinks location={link} options={{ renderers: { paragraph: 'span' } }} />
                  </span>
                ))
              }
            </div>
            <Paragraph>{translate('footer_copyright', { year: new Date().getFullYear()})}</Paragraph>
            <Paragraph>
              {translate('footer_version', { globalVersion, lastDeploymentDate })}
            </Paragraph>
          </Col>
          <ImageCol>
            <Link href="/">
              <img src={logo} alt="" />
            </Link>
          </ImageCol>
        </Row>
      </div>
      {environment && environment !== 'prod' && environment !== 'production' && (
        <InfoBar env={environment}>{translate('footer_info_bar', { environment })}</InfoBar>
      )}
    </StyledFooter>
  )
}

const Paragraph = styled.p`
  white-space: normal;
  font-size: 0.8rem;
  margin-bottom: 0.3rem;
`

const StyledFooter = styled.footer`
  background-color: ${(props) => props.theme.footer.backgroundColor};
  border-top: ${(props) => `5px solid  ${props.theme.palette.primary[0]}`};
  white-space: nowrap;
  width: 100%;

  .container {
    a { 
      color: ${({ theme }) =>  theme.link.color};
    }

    color: ${({ theme }) => theme.palette.grayscale[2]};
  }
`

const ImageCol = styled(Col)`
  text-align: right;
  margin: auto;
  
  img {
    width: 3rem;
  }
`

const InfoBar = styled.div`
  width: 100%;
  border: 0;
  z-index: 9999;
  text-align: center;
  font-size: 0.8rem;
  line-height: 1rem;
  position: fixed;
  bottom: 0;
  color: ${({ theme, env }) => env && theme.palette.env[env].color};
  background-color: ${({ theme, env }) =>
    env && theme.palette.env[env].backgroundColor};
  opacity: 0.7;
  font-weight: bold;
`

export default Footer
